import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'

Vue.use(ElementUI)


import Home from './view/home/index.vue'
import Ad from './view/ad/index.vue'
import LitApp from './view/litapp/index.vue'
import Download from './view/download/index.vue'
import Success from './view/success/index.vue'
import About from './view/about/index.vue'

import VueRouter from 'vue-router'
const routes = [{
		path: '',
		component: Home
	},
	{
		path: '/',
		component: Home
	},
	{
		path: '/home',
		component: Home
	},
	{
		path: '/ad',
		component: Ad
	},
	{
		path: '/litapp',
		component: LitApp
	},
	{
		path: '/download',
		component: Download
	},
	{
		path: '/success',
		component: Success
	},
	{
		path: '/about',
		component: About
	}
]

Vue.use(VueRouter)

const router = new VueRouter({
	mode: 'history',
	routes // routes: routes 的简写
})

new Vue({
	el: '#app',
	router: router,
	render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js